import './blocks/slider-block';
import './blocks/accordion-blocks';
import './blocks/slider-catalogue';
import './blocks/slider-gallery';



// WEBPACK FOOTER //
// ./scripts/gutenberg/gutenberg-blocks.js